import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getUserProfile } from "app/api/redux/Users/actions";

import { withRouter, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import "./styles.scss";
import { IUserResponse } from "app/api/types";
import { AxiosResponse } from "axios";

interface IProps extends RouteComponentProps {
  classNames?: string;
  user: IUserResponse;
  getUserProfile: () => Promise<AxiosResponse>;
}

const Layout: React.FC<IProps> = ({
  classNames,
  children,
  location,
  history,
  user,
  getUserProfile
}) => {
  useEffect(() => {
    if (!user.username) getUserProfile().catch(err => history.push("/signin"));
  }, [user.username, getUserProfile, history]);

  const isAdmin = user.email === "admin@admin.com";

  const [styles, setStyles] = useState("");
  return (
    <div className="layout-user">
      <div
        className="burger"
        onClick={() => setStyles(styles ? "" : "layout-user__header_active")}
      >
        &#x2630;
      </div>
      <div className={`layout-user__header ${styles}`}>
        <a href="/" className="layout-user__link">
          <div className="layout-user__logo"></div>
        </a>
        <div className="layout-user__menu">
          <Link
            to="/"
            className={
              history.location.pathname === "/" ? "link_active" : "link"
            }
          >
            Записи
          </Link>

          {isAdmin && (
            <>
              <Link
                to="/masters"
                className={
                  history.location.pathname === "/masters"
                    ? "link_active"
                    : "link"
                }
              >
                Мастера
              </Link>
              <Link
                to="/serviceCategories"
                className={
                  history.location.pathname === "/serviceCategories"
                    ? "link_active"
                    : ""
                }
              >
                Категории услуг
              </Link>
              <Link
                to="/services"
                className={
                  history.location.pathname === "/services" ? "link_active" : ""
                }
              >
                Услуги
              </Link>
              <Link to="/gallery" className={history.location.pathname === "/gallery" ? "link_active" : ""}>
                Галерея
              </Link>
              <Link
                to="/pages"
                className={
                  history.location.pathname.match(/\b(\w*pages\w*)\b/g)
                    ? "link_active"
                    : ""
                }
              >
                Страницы
              </Link>{" "}
            </>
          )}

          <Link
            to="/messages/page=1"
            className={
              history.location.pathname.match(/\b(\w*messages\w*)\b/g)
                ? "link_active"
                : ""
            }
          >
            Вопрос-ответ
          </Link>

          <Link
              to="/chat"
              className={
                history.location.pathname.match(/\b(\w*chat\w*)\b/g)
                    ? "link_active"
                    : ""
              }
          >
            Онлайн-чат
          </Link>

          {isAdmin && (
            <Link
              to="/users"
              className={
                history.location.pathname === "/users" ? "link_active" : ""
              }
            >
              Аккаунты
            </Link>
          )}
        </div>
        <div className="layout-user__profile">
          <div className="profile-name">{user.name}</div>
          <Link to="/signout" className="signout">
            выйти
          </Link>
          <div className="profile-copy">
            Сайт разработан <a href="https://statist.info">statist.info</a>
          </div>
          {/* <div className="profile-avatar" /> */}
        </div>
      </div>
      <div className={`layout-user__content ${classNames}`}>{children}</div>
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.users.profile
  };
};
export default withRouter(connect(mapStateToProps, { getUserProfile })(Layout));
